import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from '@ecster/i18n';
import { Link, Panel, PanelContent } from '@ecster/components';
import { hasLengthMoreThanZero } from '../../../common/util/has-length-more-than-zero';
import { isNumber } from '../../../common/util/is-number';
import { formatAmount } from '../../../common/util/format-amount';
import { formatNumber } from '../../../common/util/format-number';
import { InfoItem } from './InfoItem';

export default class AccountInformationTab extends React.Component {
    render() {
        const {
            accountCard,
            terms: {
                interestRate,
                depositRate,
                termsPDFURL,
                adminFee,
                withdrawalFeePercent,
                withdrawalFee,
                currencyExchangeFeeRate,
                yearlyFee,
                cardFee,
                lateFee,
                overdraft,
            },
        } = this.props;
        const { brickId } = accountCard;
        const hasCard = hasLengthMoreThanZero(brickId);

        const hasWithdrawalFeePercent = isNumber(withdrawalFeePercent) && withdrawalFeePercent > 0;

        return (
            <Panel className="account-info-panel" stretchInMobile paddingAll="small">
                <h2 className="h3">{i18n('account.account-information.information.header')}</h2>

                <div>
                    <PanelContent fullWidth horizontalLines>
                        <div>
                            <InfoItem
                                value={`${formatNumber(interestRate, { decimals: 2 })} %`}
                                label={i18n('account.account-information.information.interest-rate-label')}
                                description={i18n('account.account-information.information.interest-rate-description')}
                            />
                            {depositRate > 0 && (
                                <InfoItem
                                    value={`${formatNumber(depositRate, { decimals: 2 })} %`}
                                    label={i18n('account.account-information.information.se.deposit-rate')}
                                    description={
                                        <span>
                                            {i18n(
                                                'account.account-information.information.se.deposit-rate-description'
                                            )}{' '}
                                            <Link
                                                target="_blank"
                                                href={termsPDFURL}
                                                id="open-account-terms-pdf-link1"
                                                rel="noreferrer"
                                            >
                                                pdf
                                            </Link>
                                        </span>
                                    }
                                />
                            )}

                            <InfoItem
                                value={formatAmount(adminFee)}
                                label={i18n('account.account-information.information.se.admin-fee')}
                                description={i18n('account.account-information.information.se.admin-fee-description')}
                            />

                            {hasWithdrawalFeePercent ? (
                                <InfoItem
                                    value={i18n('account.account-information.information.se.withdrawal-fee-value', {
                                        percentValue: `${formatNumber(withdrawalFeePercent, {
                                            decimals: 2,
                                        })} %`,
                                        feeValue: formatAmount(withdrawalFee),
                                    })}
                                    label={i18n('account.account-information.information.se.withdrawal-fee')}
                                    description={i18n(
                                        'account.account-information.information.se.withdrawal-fee-description'
                                    )}
                                />
                            ) : (
                                <InfoItem
                                    value={formatAmount(withdrawalFee)}
                                    label={i18n('account.account-information.information.se.withdrawal-fee')}
                                    description={i18n(
                                        'account.account-information.information.se.withdrawal-fee-description'
                                    )}
                                />
                            )}
                            {isNumber(currencyExchangeFeeRate) && (
                                <InfoItem
                                    value={`${formatNumber(currencyExchangeFeeRate, {
                                        decimals: 2,
                                    })} %`}
                                    label={i18n('account.account-information.information.se.exchange-fee')}
                                    description={i18n(
                                        'account.account-information.information.se.exchange-fee-description'
                                    )}
                                />
                            )}

                            <InfoItem
                                value={formatAmount(yearlyFee)}
                                label={i18n('account.account-information.information.se.yearly-fee')}
                                description={i18n('account.account-information.information.se.yearly-fee-description')}
                            />

                            {hasCard && (
                                <InfoItem
                                    value={formatAmount(cardFee)}
                                    label={i18n('account.account-information.information.card-fee')}
                                    description={i18n('account.account-information.information.card-fee-description')}
                                />
                            )}

                            {isNumber(lateFee) && (
                                <InfoItem
                                    value={formatAmount(lateFee)}
                                    label={i18n('account.account-information.information.late-fee')}
                                    description={i18n('account.account-information.information.late-fee-description')}
                                />
                            )}
                            {isNumber(overdraft) && (
                                <InfoItem
                                    value={formatAmount(overdraft)}
                                    label={i18n('account.account-information.information.overdraft-fee')}
                                    description={i18n(
                                        'account.account-information.information.overdraft-fee-description'
                                    )}
                                />
                            )}
                            <p className="pt-5 pl-6">
                                {i18n('account.account-information.information.agreement-info')}
                            </p>
                        </div>
                    </PanelContent>
                </div>
            </Panel>
        );
    }
}

/* istanbul ignore next */
// eslint-disable-next-line

AccountInformationTab.propTypes = {
    // ajax action and its async states
    accountCard: PropTypes.shape(),
    terms: PropTypes.object,
};

AccountInformationTab.defaultProps = {
    accountCard: {},
    terms: null,
};
